import { Project, TeamMember, Contact, Label } from "@/types";

export const labels: Label[] = [
  { id: "1", name: "Automation", color: "bg-blue-500" },
  { id: "2", name: "API", color: "bg-green-500" },
  { id: "3", name: "Web", color: "bg-purple-500" },
  { id: "4", name: "RPA", color: "bg-orange-500" },
  { id: "5", name: "Mobile", color: "bg-pink-500" },
  { id: "6", name: "Backend", color: "bg-indigo-500" },
];

export const initialProjects: Project[] = [
  {
    id: "1",
    title: "E-Commerce Platform",
    client: "TechMart Inc.",
    assignee: "Emre",
    priority: "High",
    status: "Potential",
    startDate: new Date("2025-01-15"),
    endDate: new Date("2025-04-30"),
    deadline: new Date("2025-04-30"),
    followUp: false,
    labels: [labels[2], labels[1]],
    description: "Building a modern e-commerce platform with advanced features",
    tasks: [
      {
        id: "t1",
        title: "Setup project structure",
        description: "Initialize project with proper folder structure",
        status: "Todo",
        assignee: "Emre",
        priority: "High",
        createdAt: new Date(),
        deadline: new Date("2025-01-20"),
        followUp: true,
      },
      {
        id: "t2",
        title: "Design database schema",
        description: "Create ERD and database design",
        status: "Todo",
        assignee: "Emre",
        priority: "High",
        createdAt: new Date(),
        deadline: new Date("2025-01-25"),
        followUp: false,
      },
    ],
  },
  {
    id: "2",
    title: "Invoice Automation System",
    client: "FinanceFlow Ltd.",
    assignee: "Gürkan",
    priority: "High",
    status: "Potential",
    startDate: new Date("2025-01-20"),
    endDate: new Date("2025-03-15"),
    deadline: new Date("2025-03-15"),
    followUp: false,
    labels: [labels[0], labels[3]],
    description: "Automated invoice processing and management system",
    tasks: [
      {
        id: "t3",
        title: "Research automation tools",
        description: "Evaluate RPA tools for invoice processing",
        status: "Todo",
        assignee: "Gürkan",
        priority: "Medium",
        createdAt: new Date(),
        followUp: false,
      },
    ],
  },
  {
    id: "3",
    title: "Mobile Banking App",
    client: "SecureBank",
    assignee: "Buinsoft Dev Team",
    priority: "Medium",
    status: "Potential",
    startDate: new Date("2025-02-01"),
    endDate: new Date("2025-06-30"),
    followUp: false,
    labels: [labels[4], labels[1]],
    description: "Secure mobile banking application for iOS and Android",
    tasks: [],
  },
  {
    id: "4",
    title: "CRM Integration",
    client: "SalesPro Solutions",
    assignee: "Emre",
    priority: "High",
    status: "Active",
    startDate: new Date("2025-01-05"),
    endDate: new Date("2025-02-28"),
    deadline: new Date("2025-02-28"),
    followUp: false,
    labels: [labels[1], labels[5]],
    description: "Integrate third-party CRM with existing systems",
    tasks: [
      {
        id: "t4",
        title: "API authentication setup",
        description: "Configure OAuth and API keys",
        status: "In Progress",
        assignee: "Emre",
        priority: "High",
        createdAt: new Date(),
        deadline: new Date("2025-01-18"),
        followUp: true,
      },
      {
        id: "t5",
        title: "Data mapping",
        description: "Map CRM fields to internal database",
        status: "Todo",
        assignee: "Emre",
        priority: "Medium",
        createdAt: new Date(),
        followUp: false,
      },
    ],
  },
  {
    id: "5",
    title: "Warehouse Management System",
    client: "LogiTech Corp.",
    assignee: "Gürkan",
    priority: "Medium",
    status: "Active",
    startDate: new Date("2025-01-10"),
    endDate: new Date("2025-04-15"),
    followUp: false,
    labels: [labels[2], labels[0]],
    description: "Real-time warehouse inventory tracking system",
    tasks: [
      {
        id: "t6",
        title: "Barcode scanner integration",
        description: "Integrate handheld scanners with system",
        status: "In Progress",
        assignee: "Gürkan",
        priority: "High",
        createdAt: new Date(),
        followUp: false,
      },
    ],
  },
  {
    id: "6",
    title: "HR Portal Redesign",
    client: "PeopleFirst Inc.",
    assignee: "Buinsoft Dev Team",
    priority: "Low",
    status: "Active",
    startDate: new Date("2025-01-08"),
    endDate: new Date("2025-03-01"),
    followUp: false,
    labels: [labels[2]],
    description: "Modern UI/UX redesign for HR management portal",
    tasks: [],
  },
  {
    id: "7",
    title: "Payment Gateway API",
    client: "PayFast Systems",
    assignee: "Emre",
    priority: "High",
    status: "In Progress",
    startDate: new Date("2024-12-15"),
    endDate: new Date("2025-02-10"),
    deadline: new Date("2025-02-10"),
    followUp: false,
    labels: [labels[1], labels[5]],
    description: "Secure payment processing API integration",
    tasks: [
      {
        id: "t7",
        title: "Security audit",
        description: "Complete security review of payment flow",
        status: "Testing",
        assignee: "Emre",
        priority: "High",
        createdAt: new Date(),
        deadline: new Date("2025-01-16"),
        followUp: true,
      },
      {
        id: "t8",
        title: "Transaction logging",
        description: "Implement comprehensive transaction logs",
        status: "Completed",
        assignee: "Emre",
        priority: "Medium",
        createdAt: new Date(),
        followUp: false,
      },
    ],
  },
  {
    id: "8",
    title: "Data Analytics Dashboard",
    client: "InsightMetrics",
    assignee: "Gürkan",
    priority: "Medium",
    status: "In Progress",
    startDate: new Date("2024-12-20"),
    endDate: new Date("2025-02-28"),
    followUp: false,
    labels: [labels[2], labels[1]],
    description: "Real-time business intelligence dashboard",
    tasks: [
      {
        id: "t9",
        title: "Chart components",
        description: "Build reusable chart components",
        status: "In Progress",
        assignee: "Gürkan",
        priority: "Medium",
        createdAt: new Date(),
        followUp: false,
      },
    ],
  },
  {
    id: "9",
    title: "Inventory Tracking System",
    client: "RetailMax",
    assignee: "Buinsoft Dev Team",
    priority: "Low",
    status: "In Progress",
    startDate: new Date("2024-12-10"),
    endDate: new Date("2025-01-30"),
    deadline: new Date("2025-01-17"),
    followUp: false,
    labels: [labels[0], labels[2]],
    description: "Automated inventory management with alerts",
    tasks: [],
  },
  {
    id: "10",
    title: "Customer Portal",
    client: "ServiceHub Co.",
    assignee: "Emre",
    priority: "High",
    status: "Done",
    startDate: new Date("2024-11-01"),
    endDate: new Date("2024-12-31"),
    followUp: false,
    labels: [labels[2], labels[1]],
    description: "Self-service customer support portal",
    tasks: [
      {
        id: "t10",
        title: "User authentication",
        description: "Implement secure login system",
        status: "Completed",
        assignee: "Emre",
        priority: "High",
        createdAt: new Date(),
        followUp: false,
      },
      {
        id: "t11",
        title: "Ticket system",
        description: "Build support ticket management",
        status: "Completed",
        assignee: "Emre",
        priority: "High",
        createdAt: new Date(),
        followUp: false,
      },
    ],
  },
  {
    id: "11",
    title: "Email Marketing Platform",
    client: "MailFlow Inc.",
    assignee: "Gürkan",
    priority: "Medium",
    status: "Done",
    startDate: new Date("2024-10-01"),
    endDate: new Date("2024-12-20"),
    followUp: false,
    labels: [labels[0], labels[1]],
    description: "Automated email campaign management system",
    tasks: [
      {
        id: "t12",
        title: "Template builder",
        description: "Drag-and-drop email template builder",
        status: "Completed",
        assignee: "Gürkan",
        priority: "Medium",
        createdAt: new Date(),
        followUp: false,
      },
    ],
  },
  {
    id: "12",
    title: "Supply Chain Optimizer",
    client: "LogiTech Corp.",
    assignee: "Buinsoft Dev Team",
    priority: "Low",
    status: "Done",
    startDate: new Date("2024-09-15"),
    endDate: new Date("2024-12-15"),
    followUp: false,
    labels: [labels[0], labels[2]],
    description: "AI-powered supply chain optimization tool",
    tasks: [],
  },
];

export const teamMembers: TeamMember[] = [
  {
    id: "1",
    name: "Emre Kılınç",
    role: "Lead Developer",
    email: "emre@buinsoft.com",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Emre",
  },
  {
    id: "2",
    name: "Gürkan Yılmaz",
    role: "Senior Developer",
    email: "gurkan@buinsoft.com",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Gurkan",
  },
  {
    id: "3",
    name: "Buinsoft Dev Team",
    role: "Development Team",
    email: "team@buinsoft.com",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Team",
  },
];

export const contacts: Contact[] = [
  {
    id: "1",
    name: "Sarah Johnson",
    company: "TechMart Inc.",
    email: "sarah.johnson@techmart.com",
    phone: "+1 (555) 123-4567",
  },
  {
    id: "2",
    name: "Michael Chen",
    company: "FinanceFlow Ltd.",
    email: "m.chen@financeflow.com",
    phone: "+1 (555) 234-5678",
  },
  {
    id: "3",
    name: "Emily Rodriguez",
    company: "SecureBank",
    email: "e.rodriguez@securebank.com",
    phone: "+1 (555) 345-6789",
  },
  {
    id: "4",
    name: "David Park",
    company: "SalesPro Solutions",
    email: "david.park@salespro.com",
    phone: "+1 (555) 456-7890",
  },
];
